import { useState } from 'react'
import * as React from 'react'
import {
  NumberField,
  TextInput,
  SelectInput,
  TextField,
  DateTimeInput,
  DateField,
  ReferenceField,
  NumberInput,
  FormDataConsumer,
  ReferenceInput,
  AutocompleteInput,
  BooleanInput,
  required,
  useTranslate,
  SelectField,
  useRecordContext,
} from 'react-admin'
import { Label, ImageFieldCustom, ImageInputCustom } from './utils'
import { ImageInputCustomFireForget } from './utils'
import { Typography, makeStyles, Grid } from '@material-ui/core'
import { Rating } from '@mui/material'
import TimePicker from './components/time_picker'
import get from 'lodash/get'
import { Add } from '@mui/icons-material/Add'

const useStyles = makeStyles(() => ({
  dropZone: {
    border: '1px dashed black',
    borderRadius: '5px',
  },
}))

export const ViewFieldWrapper = (props) => {
  const record = useRecordContext(props)
  const { processTypes } = props

  const translate = useTranslate()
  const useStyles = makeStyles(() => ({
    root: { position: 'relative', paddingLeft: '15px', marginBottom: '20px' },
    beginBar: {
      position: 'absolute',
      height: '100%',
      width: '4.5px',
      background: '#e4e6ef',
      top: 0,
      left: 0,
      borderRadius: '10px',
    },
    title: {
      fontSize: '16px',
      color: '#000000',
    },
  }))
  const classes = useStyles()

  if (!record || !record[props.field.source]) return null

  if (['Textarea', 'Text'].indexOf(props.field.type) > -1) {
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <Label
          source={props.field.source}
          label={props.field.label}
          {...props}
          className={classes.title}
        />
        <TextField
          source={props.field.source}
          label={props.field.label}
          {...props}
        />
      </div>
    )
  }
  if (props.field.type === 'Number') {
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <Label
          source={props.field.source}
          label={props.field.label}
          {...props}
          className={classes.title}
        />
        <NumberField
          source={props.field.source}
          label={props.field.label}
          {...props}
        />
      </div>
    )
  }
  if (props.field.type === 'Datetime') {
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <Label
          source={props.field.source}
          label={props.field.label}
          {...props}
          className={classes.title}
        />
        <DateField
          showTime
          source={props.field.source}
          label={props.field.label}
          {...props}
        />
      </div>
    )
  }
  if (props.field.type === 'Image') {
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <ImageFieldCustom
          {...props}
          source={props.field.source}
          label={props.field.label}
          record={record}
          timestamp={record[props.field.source + '_metadata']}
        />
      </div>
    )
  }
  if (props.field.type === 'ImageFireForget') {
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <ImageFieldCustom
          {...props}
          source={props.field.source}
          label={props.field.label}
          record={record}
          timestamp={record[props.field.source + '_metadata']}
        />
      </div>
    )
  }
  if (props.field.type === 'Boolean') {
    const value = get(props.field.record, props.field.source)
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <Label
          source={props.field.source}
          label={props.field.label}
          {...props}
          className={classes.title}
        />
        <Typography component="span" variant="body2">
          {value === 'true' ? 'Oui' : 'Non'}
        </Typography>
      </div>
    )
  }
  if (props.field.type === 'UrgenceSelect') {
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <Label
          source={props.field.source}
          label={props.field.label}
          {...props}
          className={classes.title}
        />
        <TextField
          source={props.field.source}
          label={props.field.label}
          {...props}
        />
      </div>
    )
  }
  if (props.field.type === 'JuridiqueDemandeType') {
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <Label
          source={props.field.source}
          label={props.field.label}
          {...props}
          className={classes.title}
        />
        <TextField
          source={props.field.source}
          label={props.field.label}
          {...props}
        />
      </div>
    )
  }
  if (props.field.type === 'VisiteType') {
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <Label
          source={props.field.source}
          label={props.field.label}
          {...props}
          className={classes.title}
        />
        <TextField
          source={props.field.source}
          label={props.field.label}
          {...props}
        />
      </div>
    )
  }
  if (props.field.type === 'ThemeType') {
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <Label
          source={props.field.source}
          label={props.field.label}
          {...props}
          className={classes.title}
        />
        <TextField
          source={props.field.source}
          label={props.field.label}
          {...props}
        />
      </div>
    )
  }
  if (props.field.type === 'CoproprietairesReferenceFilteredCopro') {
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <Label
          source={props.field.source}
          label={props.field.label}
          {...props}
          className={classes.title}
        />
        <ReferenceField
          label={props.field.label}
          source={props.field.source}
          reference="coproprietaires_frommonday"
          {...props}
          link={false}
        >
          <TextField source="name" />
        </ReferenceField>
      </div>
    )
  }
  if (props.field.type === 'ContractReferenceFilteredCopro') {
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <Label
          source={props.field.source}
          label={props.field.label}
          {...props}
          className={classes.title}
        />
        <ReferenceField
          label={props.field.label}
          source={props.field.source}
          reference="contracts"
          {...props}
          link={false}
        >
          <TextField source="contract_title" />
        </ReferenceField>
      </div>
    )
  }
  if (props.field.type === 'UserReference') {
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <Label
          source={props.field.source}
          label={props.field.label}
          {...props}
          className={classes.title}
        />
        <ReferenceField
          label={props.field.label}
          source={props.field.source}
          reference="users"
          {...props}
          link={false}
          sortBy="user.email"
          sortByOrder="ASC"
        >
          <TextField source="email" />
        </ReferenceField>
      </div>
    )
  }
  if (props.field.type === 'PrestaReference') {
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <Label
          source={props.field.source}
          label={props.field.label}
          {...props}
          className={classes.title}
        />
        <br />
        <ReferenceField
          label={props.field.label}
          source={props.field.source}
          reference="prestas"
          {...props}
          link={false}
        >
          <TextField source="name" />
        </ReferenceField>
      </div>
    )
  }
  if (props.field.type === 'Grade') {
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <Label
          source={props.field.source}
          label={props.field.label}
          {...props}
          className={classes.title}
        />
        <br />
        <Rating name="read-only" value={record[props.field.source]} readOnly />
      </div>
    )
  }

  if ('ChoiceType1' === props.field.type)
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <SelectField
          variant={props.variant}
          source={props.field.source}
          label={translate(props.field.label)}
          choices={[]}
          fullWidth
          validate={[required()]}
        />
      </div>
    )

  if ('Type' === props.field.type)
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <SelectField
          variant={props.variant}
          source={props.field.source}
          label={translate(props.field.label)}
          choices={processTypes ? processTypes : []}
          fullWidth
          validate={[required()]}
        />
      </div>
    )

  if ('ChoiceType2' === props.field.type)
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <SelectField
          variant={props.variant}
          source={props.field.source}
          label={translate(props.field.label)}
          choices={[]}
          fullWidth
          validate={[required()]}
        />
      </div>
    )

  if ('time_type' === props.field.type)
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <TimePicker
          variant={props.variant}
          source={props.field.source}
          label={translate(props.field.label)}
          fullWidth
        />
      </div>
    )

  return <div>Type de champ inconnu: {props.field.type}</div>
}

// iterate throught key/value of the jsonObject and inject formData for values "<replaced>"
const injectFormData = (formData, jsonObject) => {
  for (var key of Object.keys(jsonObject)) {
    let value = jsonObject[key]
    if (typeof value === 'object') {
      jsonObject[key] = injectFormData(formData, value)
    } else {
      if (
        value == 'replaced' &&
        formData &&
        Object.prototype.hasOwnProperty.call(formData, key)
      ) {
        jsonObject[key] = formData[key]
      }
    }
  }
  return jsonObject
}

//NOTE: the ImageInput component needs to access form value for base64 string
//so we require a formData prop on this component.
//We cannot use the record because in tickets form in BO,
//This component is wrapped in a Show component that fetches the process and associated fields
//so our props.record gets overridden. (however binding with outer SimpleForm works well, it's only
//a problem to access other fields data)
// @todo: We should redo this function in order to accept at least the default input type properties.
export const InputFieldWrapper = (props) => {
  const { processTypes } = props
  const [old_copro_id, setOldCopro] = useState(undefined)
  const [value, setValue] = React.useState(null)
  const rest = { fullWidth: true }
  const classes = useStyles()
  const translate = useTranslate()

  const validations = []
  if (props.field.required) {
    validations.push(required())
  }

  let filter = JSON.parse(JSON.stringify(props.field.filter)) || {}
  filter = injectFormData(props.formData, filter)

  if (props.field.type === 'Text') {
    return (
      <TextInput
        disabled={props.disabled || false}
        source={props.field.source}
        label={props.field.label}
        variant={props.variant}
        {...rest}
        validate={validations}
      />
    )
  }

  if (props.field.type === 'Textarea') {
    let breaks =
      props.formData && props.formData[props.field.source]
        ? (props.formData[props.field.source].match(/[\n\r]+/g) || []).length
        : 0
    let spaces =
      props.formData && props.formData[props.field.source]
        ? (props.formData[props.field.source].match(/[\s]+/g) || []).length
        : 0
    let lines = Math.max(6, breaks + spaces / 10)
    return (
      <TextInput
        multiline={true}
        rows={lines}
        disabled={props.disabled || false}
        source={props.field.source}
        label={props.field.label}
        variant={props.variant}
        {...rest}
        validate={validations}
      />
    )
  }
  if (props.field.type === 'Number') {
    return (
      <NumberInput
        source={props.field.source}
        label={props.field.label}
        variant={props.variant}
        {...rest}
        validate={validations}
      />
    )
  }
  if (props.field.type === 'Datetime') {
    return (
      <DateTimeInput
        source={props.field.source}
        label={props.field.label}
        variant={props.variant}
        {...rest}
        validate={validations}
      />
    )
  }
  if (props.field.type === 'Image') {
    return (
      <ImageInputCustom
        {...rest}
        classes={{ dropZone: classes.dropZone }}
        labelMultiple="Déposez les fichiers ou cliquez ici pour en sélectionner."
        from="ext_tickets"
        source={props.field.source}
        label={props.field.label}
        variant={props.variant}
        record={props.formData}
        deletable={false}
        validate={validations}
      />
    )
  }
  if (props.field.type === 'ImageFireForget') {
    return (
      <ImageInputCustomFireForget
        {...rest}
        from="ext_tickets"
        source={props.field.source}
        label={props.field.label}
        variant={props.variant}
        record={props.formData}
        deletable={false}
        validate={validations}
      />
    )
  }
  if (props.field.type === 'Boolean') {
    return (
      <BooleanInput
        source={props.field.source}
        label={props.field.label}
        variant={props.variant}
        checked={[true, 'true'].includes(props.formData[props.field.source])}
        {...rest}
        validate={validations}
      />
    )
  }
  //NOTE: this is a contact field so it must be mandatory (else some roles may be unspecified)
  if (props.field.type === 'PrestaReference') {
    //Autocomplete does not bind to an already existing form value, so we double with a SelectInput

    return (
      <ReferenceInput
        label={props.field.label}
        source={props.field.source}
        reference="prestas"
        variant={props.variant}
        fullWidth
      >
        <AutocompleteInput
          optionText="name"
          fullWidth
          label={props.field.label}
          matchSuggestion={() => true}
          validate={validations}
        />
      </ReferenceInput>
    )
  }
  //NOTE: this is a contact field so it must be mandatory (else some roles may be unspecified)
  if (props.field.type === 'UserReference') {
    return (
      <ReferenceInput
        label={props.field.label}
        source={props.field.source}
        sort={{ field: 'email', order: 'ASC' }}
        reference="users"
        filter={filter}
        variant={props.variant}
        fullWidth
      >
        <AutocompleteInput
          optionText="email"
          fullWidth
          label={props.field.label}
          matchSuggestion={() => true}
          validate={validations}
        />
      </ReferenceInput>
    )
  }
  if (props.field.type === 'UrgenceSelect') {
    return (
      <SelectInput
        label={props.field.label}
        source={props.field.source}
        choices={[
          { id: 'Petite intervention', name: 'Petite intervention' },
          { id: 'Urgent', name: 'Urgent' },
        ]}
        variant={props.variant}
        {...rest}
        validate={validations}
      />
    )
  }
  if (props.field.type === 'ThemeType') {
    return (
      <SelectInput
        label={props.field.label}
        source={props.field.source}
        choices={[
          {
            id: 'Question sur un appel de fonds ou relevé',
            name: 'Question sur un appel de fonds ou relevé',
          },
          {
            id: "Envoi d'un appel de fonds",
            name: "Envoi d'un appel de fonds",
          },
          { id: "Envoi d'un PV d'AG", name: "Envoi d'un PV d'AG" },
          { id: "Envoi d'un RCP", name: "Envoi d'un RCP" },
          {
            id: "Demande d'information sur une AG",
            name: "Demande d'information sur une AG",
          },
          {
            id: "Demande d'information sur une intervention",
            name: "Demande d'information sur une intervention",
          },
          { id: 'Autre', name: 'Autre' },
        ]}
        variant={props.variant}
        {...rest}
      />
    )
  }
  //NOTE: this is a contact field so it must be mandatory (else some roles may be unspecified)
  if (props.field.type === 'CoproprietairesReferenceFilteredCopro') {
    const copromaticStatus = props.formData.copro?.copromaticStatus
    const validationsRules =
      copromaticStatus === 'administrative_integration' ||
      copromaticStatus === 'accounting_integration'
        ? validations.filter((val) => val !== required())
        : validations
    return (
      <ReferenceInput
        source={props.field.source}
        reference="coproprietaires_frommonday"
        variant={props.variant}
        filter={filter}
        fullWidth
      >
        <AutocompleteInput
          optionText="name"
          validate={validationsRules}
          fullWidth
          label={props.field.label}
          matchSuggestion={() => true}
        />
      </ReferenceInput>
    )
  }
  if (props.field.type === 'ContractReferenceFilteredCopro') {
    return (
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          if (formData.copro_id === undefined) {
            return null
          }
          //if it's not the first time we load, and if copro_id has changed,
          //we return null to make sure we destroy ReferenceInput so that on next run
          //it's recreated and reloads the right list of coproprietaires
          if (
            old_copro_id !== undefined &&
            old_copro_id !== formData.copro_id
          ) {
            setOldCopro(formData.copro_id)
            formData[props.field.source] = null
            return null
          } else {
            setOldCopro(formData.copro_id)
          }

          window.context['context-copro'] = formData.copro_id
          //I couldn't figure out why the SelectInput is not as large as other select inputs in this form.
          //It was the case even with a Custom component that was not FormDataConsumer
          //so we use this dirty hack
          return (
            <ReferenceInput
              label={props.field.label}
              source={props.field.source}
              reference="contracts_frommonday"
              allowEmpty={true}
              variant={props.variant}
            >
              <SelectInput
                {...rest}
                optionText="contract_title"
                validate={validations}
              />
            </ReferenceInput>
          )
        }}
      </FormDataConsumer>
    )
  }
  if (props.field.type === 'Grade') {
    return (
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          if (window.varShouldNotDoThat !== undefined) {
            formData[props.field.source] = window.varShouldNotDoThat
          } else {
            window.varShouldNotDoThat = formData[props.field.source]
          }

          //NOTE: I don't know why this code does not work.
          //I had issues when saving the form, after the save was done,
          //formData had a wrong value for the rating field, even though
          //the right value was sent to the API, and then received from the API.
          //So instead we use a variable on window object
          // //If first time loading the component, formdata is the master
          // if (value === null) {
          //   setValue(formData[props.field.source]);
          // } else {
          //   //else value is the master
          //   formData[props.field.source] = window.varShouldNotDoThat;
          // }

          return (
            <div>
              <br />
              <Label
                source={props.field.source}
                label={props.field.label}
                {...props}
              />
              <Rating
                name="simple-controlled"
                value={window.varShouldNotDoThat}
                onChange={(event, newValue) => {
                  //we persist the value
                  window.varShouldNotDoThat = newValue
                  //we trigger a re-render by editing a state variable
                  setValue(newValue)
                }}
              />
            </div>
          )
        }}
      </FormDataConsumer>
    )
  }

  if ('Type' === props.field.type)
    return (
      <AutocompleteInput
        {...rest}
        variant={props.variant}
        source={props.field.source}
        label={translate(props.field.label)}
        choices={processTypes ? processTypes : []}
        fullWidth
        validate={validations}
        optionValue="name"
        optionText="name"
      />
    )

  if ('time_type' === props.field.type)
    return (
      <TimePicker
        variant={props.variant}
        source={props.field.source}
        label={translate(props.field.label)}
        fullWidth
      />
    )

  return <div>Type de champ inconnu: {props.field.type}</div>
}

//------------ For tickets extranet we want only fields for current state_transition

export const DynamicViewComponentExtranet1 = (props) => {
  const { record } = props
  if (record.state_transition === null) {
    return null
  }
  return (
    <Grid item xs={12} sm={6}>
      <div>
        {record?.state_transition?.view_columns?.map((field) => {
          return (
            <ViewFieldWrapper field={field} key={field.source} {...props} />
          )
        })}
      </div>
    </Grid>
  )
}

export const DynamicInputComponentExtranet1 = (props) => {
  const record = useRecordContext()
  if (record.state_transition === null) {
    console.warn('record has no state_transition', record)
    return null
  }
  return (
    <div>
      {record.state_transition.input_columns.map((field) => {
        return (
          <InputFieldWrapper
            formData={record}
            field={field}
            key={field.source}
            {...props}
          />
        )
      })}
    </div>
  )
}

//------------ For BO we want only fields that are not input fields for anyone in the process

export const DynamicInputComponentBO = ({ children, ...props }) => {
  const record = useRecordContext(props)
  if (!record || !record.fields) {
    return null
  }
  let processTypes = record.types ? [...record.types] : []
  processTypes = processTypes.sort().map((item, i) => {
    return {
      id: i,
      name: item,
    }
  })
  // Recorda que estas verificando como comprobar que tiene copropietare para mostrar el boton
  let result = []
  if (record.name) {
    result.push(
      <Typography
        variant="subtitle1"
        color="primary"
        key={`DynamicInputComponentBO-${result.length}`}
      >
        {record.name}
      </Typography>
    )
  }
  result = result.concat(
    record.fields
      .filter((field) => field.locked !== true)
      .map((field) => (
        <InputFieldWrapper
          {...props}
          disabled={
            props.disabledFields && props.disabledFields.indexOf(field.id) > -1
          }
          formData={props.formData}
          field={field}
          key={`DynamicInputComponentBO-${field.source}-${result.length}`}
          processTypes={processTypes}
        />
      ))
  )
  if (children) {
    if (!Array.isArray(children)) {
      children = [children]
    }
    children.forEach((child) => {
      if (child && child.props && child.props.insertAt !== undefined) {
        result.splice(child.props.insertAt, 0, child)
      } else {
        result.push(child)
      }
    })
  }
  //we filter fields that are input fields in espace unique
  return <>{result}</>
}

//NOTE: here, we are inside a Show component on process resources, because that is where we get the fields from.
//So the props.record is a process, we need to pass to ViewFieldWrapper the ticket data under props.record
//NOTE: the formData={props.record} we use gets props.record from the outer Show, this is how we get the outer ticket data.
//In extranet we don't need this sub Show to fetch the process so we don't need this hack
export const DynamicViewComponentBO = (props) => {
  const record = useRecordContext(props)
  const { formData, ...rest } = props
  if (!record || !record.ticket_fields) {
    return null
  }

  return (
    <div>
      {record.ticket_fields.map((field) => {
        return (
          field.source && (
            <div>
              <ViewFieldWrapper
                formData={formData}
                record={record}
                field={field}
                key={field.source}
                {...rest}
              />
              <br />
            </div>
          )
        )
      })}
    </div>
  )
}

//------------ For PAC, we show the detail of a ticket
//The backend returns only the fields with pac_visible = True
//so no need to filter anything here.
// record = a ticket

export const DynamicViewComponentPAC = ({ record }) => {
  if (record.fields === null) {
    return null
  }
  if (record?.fields?.length === 0) {
    return null
  }

  return (
    <div>
      {record?.fields?.map((field) => {
        //NOTE: the ReferenceField instances in ViewFieldWrapper need the basePath prop, don't know why
        return (
          <div>
            <ViewFieldWrapper field={field} key={field.source} basePath="/" />
            <br />
          </div>
        )
      })}
    </div>
  )
}

//------------ For self-ticketing we want only fields allowed for self ticketing

export const DynamicInputComponentSelf = (props) => {
  const { showTitle = true } = props

  const record = useRecordContext()
  if (!record) {
    return null
  }
  if (record.fields === null) {
    return null
  }
  let processTypes = record.types ? [...record.types] : []
  processTypes = processTypes.sort().map((item, i) => {
    return {
      id: i,
      name: item,
    }
  })

  const fields = record.fields.filter((field) => field.ext_published === true)

  return (
    <>
      {record.name && fields.length > 0 && showTitle && (
        <Typography variant="subtitle1" color="primary">
          {record.name}
        </Typography>
      )}
      {fields.map((field) => (
        <InputFieldWrapper
          {...props}
          processTypes={processTypes}
          formData={props.formData}
          field={field}
          key={field.source}
          fullWidth
        />
      ))}
    </>
  )
}
